module.exports = __webpack_public_path__ + "static/media/ice_help.083f0ded.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ice_help.png
// module id = 45
// module chunks = 0